import axios from 'axios';
import React from 'react';
import { FaCheck, FaUserCog } from 'react-icons/fa';
import { MdAdminPanelSettings } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import usePosts from '../../hooks/usePosts';

const AdminDashboard = () => {

    const [posts] = usePosts();

    let rePosts = posts?.filter(post => post?.isReported === true);

    const handleUpdatedData = async (newPost) => {
        await axios.put("https://tripaide-server.onrender.com/posts", newPost)
            .then(res => {
                //console.log(res.data);
                window.location.reload();
            });
    };

    const handleResolve = (post) => {
        const updatedData = {
            id: post.id,
            isReported: false,
            reporter: ""
        };
        toast.success("Post is resolved!")
        //console.log(updatedData);
        handleUpdatedData(updatedData);
    }
    const handleDelete = async (post) => {
        await axios.delete(`https://tripaide-server.onrender.com/posts/${post.id}`)
            .then(res => {
                if (res.data.deletedCount) {
                    toast.warn("Post is deleted.");
                    window.location.reload();
                }
            })
    }

    return (
        <div>
            <div>
                <Link to='/changerole' className="inline-block px-3 py-2 mr-4 mt-4 mb-16 rounded bg-pink-600 font-bold text-white">
                    <span className='flex items-center'>
                        <MdAdminPanelSettings className='text-lg mr-2' />
                        <span>Change User Role</span>
                    </span>
                </Link>
                <div>
                    <div className="flex flex-col justify-center h-full">
                        <div className="w-full max-w-2xl bg-white shadow-lg rounded-sm border border-gray-200">
                            <header className="px-5 py-4 border-b border-gray-100">
                                <div className="font-semibold text-gray-800">Manage Reported Posts</div>
                            </header>

                            <div className="overflow-x-auto p-3">
                                <table className="table-auto w-full">
                                    <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                                        <tr>
                                            <th></th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Post Id</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="text-green-600 font-semibold text-center">Resolve</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="text-red-600 font-semibold text-center">Delete</div>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="text-sm divide-y divide-gray-100">
                                        {
                                            rePosts?.map(p =>
                                                <tr key={p._id}>
                                                    <td className="p-2"></td>
                                                    <td className="p-2">
                                                        <div className="text-left">{p.id}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="flex justify-center">
                                                            <button onClick={() => handleResolve(p)}>
                                                                <div className='flex items-center justify-center w-8 h-8 hover:text-green-600 rounded-full hover:bg-gray-100 p-1'>
                                                                    <FaCheck className='text-lg' />
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="flex justify-center">
                                                            <button onClick={() => handleDelete(p)}>
                                                                <svg className="w-8 h-8 hover:text-red-600 rounded-full hover:bg-gray-100 p-1"
                                                                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                                                    </path>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;